import http from 'hub-http/clients/apiClient';
import noPortalHttp from 'hub-http/clients/noPortalApiClient';
export const CONNECTION_API_BASE_V3 = '/apps-hublets/public/v3/connection';
export const getAppInfoByClientId = clientId => {
  return noPortalHttp.get(`${CONNECTION_API_BASE_V3}/info/client-id/${clientId}`);
};
export const fetchInternallyDevelopedApps = () => {
  return http.get(`${CONNECTION_API_BASE_V3}/internally-developed`);
};